import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
// import Pricing from './components/Pricing';
import Footer from './components/Footer';
import Chatbot from './components/Chatbot';
import ThemeToggle from './components/ThemeToggle';
import Contact from './components/Contact';
import Services from './components/Services';
import Cta from './components/cta';
import { useEffect } from "react";
import ContactDetails from './components/ContactDetails';


function App() {
  useEffect(() => {
    // Title
    document.title = "InnoRock – AI Agents for Business Automation";

    // Meta description
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "InnoRock helps small and mid-sized businesses automate repetitive work using AI agents for FAQs, email replies, and summaries."
      );
    }

    // Canonical URL
    const canonical = document.querySelector("link[rel='canonical']");
    if (canonical) {
      canonical.setAttribute("href", "https://innorock.org/");
    }
  }, []);
  return (
    <>
      <Header />
      <ThemeToggle />
      <Hero />
      <Cta />
      <About /> 
      <Services />
      {/* <Chatbot /> */}
      <Contact />
      <ContactDetails />
      {/* <Pricing /> */}
      <Footer />
    </>
  );
}

export default App;
